<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-4 text-primary">
        <br />
        <b>Life in Paxel</b>
      </h5>
    </div>
    <b-card class="text-left">
      <b>Create New Story</b>
      <b-row class="mt-4">
        <b-col>
          <b-form-group id="fieldset-1" label="Title (Bahasa)" label-for="input-1">
            <input
              placeholder="Title In Bahasa"
              v-model="title_id"
              v-validate="'required|min:5|max:30'"
              name="title_id"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Title (English)" label-for="input-1">
            <input
              placeholder="Title In English"
              v-model="title_en"
              v-validate="'required|min:5|max:30'"
              name="title_en"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Content (Bahasa)" label-for="input-1">
            <textarea
              id="textarea"
              placeholder="Content In Bahasa"
              v-model="contentdes_id"
              v-validate="'required|min:5|max:30'"
              name="contentdes_id"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-contentdes_id-feedback"
            >{{ veeErrors.first('contentdes_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Content (English)" label-for="input-1">
            <textarea
              id="textarea"
              placeholder="Content In English"
              v-model="contentdes_en"
              v-validate="'required|min:5|max:30'"
              name="contentdes_en"
              class="form-control"
            ></textarea>
            <b-form-invalid-feedback
              id="input-contentdes_en-feedback"
            >{{ veeErrors.first('contentdes_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Media" label-for="input-1">
            <b-form-radio-group
              v-model="media"
              :options="options"
              v-validate="'required'"
              name="radio-inline1"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-inline1') }}</p>
          </b-form-group>
        </b-col>
        <b-col md="4"></b-col>
      </b-row>
      <b-row class="mb-3" v-show="media == 'upload' || media == 'embeded'">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="URL" v-show="media == 'embeded'" label-for="input-1">
            <input
              placeholder="Link"
              v-model="link"
              v-validate="media == 'embeded' ? 'required|max:30' : 'max:30'"
              name="link"
              class="form-control"
            />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('link') }}</p>
          </b-form-group>
          <b-form-group
            id="fieldset-1"
            label="Media File"
            label-for="input-1"
            v-show="media == 'upload'"
          >
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Image</b>
                    <sup class="text-secondary pl-3">(2 Mb)&nbsp;(98px x 131px)</sup>
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="file"
                      v-validate="media == 'upload' ? 'required|size:2000' : 'size:2000'"
                      name="file"
                      style="display: none"
                      v-on:change="onChangeFileUpload()"
                    />
                    <b-button
                      @click="$refs.file.click()"
                      v-show="!file"
                      variant="primary"
                      class="ml-5"
                    >Select File</b-button>
                    <b-button
                      v-show="file"
                      variant="primary"
                      @click="modalImage = !modalImage"
                      class="mr-2"
                    >Preview</b-button>
                    <b-button
                      @click="$refs.file.click()"
                      v-show="file"
                      variant="outline-primary"
                      class
                    >Change File</b-button>
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('file') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2" class="pr-0">
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              v-model="selected2"
              v-validate="'required'"
              :options="options2"
              name="radio-inline2"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-inline2') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >Save</b-button>
          <router-link :to="{name: 'pxLifeInPaxel'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      media: null,
      selected: null,
      selected2: null,
      title_id: '',
      modalImage: false,
      urlImage: '',
      title_en: '',
      contentdes_id: '',
      contentdes_en: '',
      link: '',
      file: '',
      options: [
        { text: 'Upload', value: 'upload' },
        { text: 'Embed', value: 'embeded' },
      ],
      options2: [
        { text: 'Publish', value: 'publish' },
        { text: 'Archive', value: 'archive' },
      ],
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const formData = new FormData();
          formData.append('url', this.link);
          formData.append('image', this.file);
          formData.append('media', this.media);
          formData.append('title_id', this.title_id);
          formData.append('title_en', this.title_en);
          formData.append('content_id', this.contentdes_id);
          formData.append('content_en', this.contentdes_en);
          formData.append('status', this.selected2);

          this.loading = true;
          this.$store
            .dispatch('lifeInPaxelModule/postLifeInPaxel', formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: 'pxLifeInPaxel' });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal('ERROR!', this.veeErrors, 'warning');
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      this.InputImage = true;
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
  },
  computed: {
    isCompleted() {
      return (
        this.selected
        && this.selected2
        && this.link
        && this.title_id
        && this.title_en
        && this.contentdes_id
        && this.contentdes_en
      );
    },
  },
};
</script>

<style>
</style>
